(function() {
  var root = document.getElementById("wl-camera-page");
  if (!root || root.dataset.dogProfileBridgeReady === "true") return;
  root.dataset.dogProfileBridgeReady = "true";

  var PROFILE_KEY = "waglife_dog_profiles";
  var SELECTED_KEY = "waglife_selected_dog_id";
  var MEMORY_KEY = "waglife_memories";

  var select = document.getElementById("wl-camera-dog-select");
  var card = document.getElementById("wl-camera-dog-link");
  var photo = document.getElementById("wl-camera-dog-photo");
  var nameLabel = document.getElementById("wl-camera-dog-name");
  var metaLabel = document.getElementById("wl-camera-dog-meta");
  var caption = document.getElementById("wl-camera-caption");
  var templateButtons = Array.prototype.slice.call(
    root.querySelectorAll("[data-caption]")
  );

  if (!select || !card || !photo || !nameLabel || !metaLabel) return;

  var profiles = [];
  var selectedId = "";
  var originalSetItem = Storage.prototype.setItem;
  var patchInstalled = false;

  function readProfiles() {
    try {
      var parsed = JSON.parse(localStorage.getItem(PROFILE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn("WagLife Camera IQ could not read dog profiles:", error);
      return [];
    }
  }

  function getSelectedDog() {
    return profiles.find(function(profile) {
      return profile.id === selectedId;
    }) || null;
  }

  function escapeText(value) {
    return String(value || "");
  }

  function dogMeta(dog) {
    return [dog.breed, dog.age || dog.size]
      .filter(Boolean)
      .join(" · ") || "My Dog profile";
  }

  function renderPhoto(dog) {
    var image = dog && dog.photo ? dog.photo : "";
    photo.style.backgroundImage = image ? "url('" + image + "')" : "";
    photo.innerHTML = image ? "" : '<span aria-hidden="true">🐾</span>';
  }

  function updateCaptionTemplates(dog) {
    templateButtons.forEach(function(button) {
      var original = button.dataset.originalCaption || button.dataset.caption || "";
      if (!button.dataset.originalCaption) {
        button.dataset.originalCaption = original;
      }

      if (/Scout approved/i.test(original)) {
        var dogName = dog && dog.name ? dog.name : "My dog";
        var updated = dogName + " approved this adventure.";
        button.dataset.caption = updated;
        button.textContent = dogName + " approved";
      }
    });
  }

  function renderSelectedDog() {
    var dog = getSelectedDog();

    if (!dog) {
      card.classList.add("is-missing");
      nameLabel.textContent = profiles.length ? "Choose a dog" : "No dog profile yet";
      metaLabel.textContent = profiles.length
        ? "Select which dog this memory belongs to."
        : "Create a My Dog profile before saving personalized memories.";
      renderPhoto(null);
      updateCaptionTemplates(null);
      return;
    }

    card.classList.remove("is-missing");
    nameLabel.textContent = dog.name || "Unnamed Dog";
    metaLabel.textContent = dogMeta(dog);
    renderPhoto(dog);
    updateCaptionTemplates(dog);
  }

  function renderOptions() {
    profiles = readProfiles();

    if (!selectedId) {
      selectedId = localStorage.getItem(SELECTED_KEY) || "";
    }

    if (profiles.length && !profiles.some(function(dog) { return dog.id === selectedId; })) {
      selectedId = profiles[0].id;
      localStorage.setItem(SELECTED_KEY, selectedId);
    }

    select.innerHTML = '<option value="">Choose dog</option>';

    profiles.forEach(function(dog) {
      var option = document.createElement("option");
      option.value = dog.id;
      option.textContent = dog.name || "Unnamed Dog";
      select.appendChild(option);
    });

    select.value = selectedId;
    renderSelectedDog();
  }

  function enrichMemory(memory, dog) {
    if (!memory || typeof memory !== "object" || !dog) return memory;

    var enriched = Object.assign({}, memory);
    enriched.dogId = dog.id;
    enriched.petId = dog.id;
    enriched.pet = dog.name || "My Dog";
    enriched.dogName = dog.name || "My Dog";
    enriched.dogPhoto = dog.photo || "";
    enriched.dogBreed = dog.breed || "";
    enriched.dogSnapshot = {
      id: dog.id,
      name: dog.name || "My Dog",
      photo: dog.photo || "",
      breed: dog.breed || "",
      age: dog.age || "",
      size: dog.size || ""
    };

    return enriched;
  }

  function installMemoryStorageBridge() {
    if (patchInstalled) return;
    patchInstalled = true;

    Storage.prototype.setItem = function(key, value) {
      if (this === localStorage && key === MEMORY_KEY) {
        try {
          var dog = getSelectedDog();
          var incoming = JSON.parse(value);

          if (dog && Array.isArray(incoming)) {
            var existing = [];
            try {
              existing = JSON.parse(localStorage.getItem(MEMORY_KEY) || "[]");
              if (!Array.isArray(existing)) existing = [];
            } catch (error) {
              existing = [];
            }

            var existingIds = {};
            existing.forEach(function(memory) {
              if (memory && memory.id) existingIds[memory.id] = true;
            });

            incoming = incoming.map(function(memory, index) {
              var isNewById = memory && memory.id && !existingIds[memory.id];
              var isNewByPosition = !memory.id && index >= existing.length;
              var alreadyLinked = memory && (
                memory.dogId || memory.petId || memory.dogName || memory.pet
              );

              if ((isNewById || isNewByPosition) && !alreadyLinked) {
                return enrichMemory(memory, dog);
              }

              return memory;
            });

            value = JSON.stringify(incoming);
          }
        } catch (error) {
          console.warn("WagLife Camera IQ could not attach dog identity:", error);
        }
      }

      return originalSetItem.call(this, key, value);
    };
  }

  select.addEventListener("change", function() {
    selectedId = select.value;

    if (selectedId) {
      localStorage.setItem(SELECTED_KEY, selectedId);
    } else {
      localStorage.removeItem(SELECTED_KEY);
    }

    renderSelectedDog();
  });

  window.addEventListener("storage", function(event) {
    if (event.key === PROFILE_KEY || event.key === SELECTED_KEY) {
      selectedId = localStorage.getItem(SELECTED_KEY) || "";
      renderOptions();
    }
  });

  document.addEventListener("visibilitychange", function() {
    if (!document.hidden) {
      selectedId = localStorage.getItem(SELECTED_KEY) || "";
      renderOptions();
    }
  });

  installMemoryStorageBridge();
  renderOptions();
})();